
import { useState, useEffect } from "react";
import StudentLogin from "./StudentLogin/StudentLogin";
import TutorLogin from "./TutorLogin/TutorLogin";
import { useLocation } from "react-router-dom";


const LoginPage = () => {
    const location = useLocation();
    const user = location.state?.user; // Get the user type from location state

    // State to track the active tab
    const [activeTab, setActiveTab] = useState("student");

    useEffect(() => {
        if (user === "tutor") {
            setActiveTab("tutor"); // Set Tutor login as active
        } else if (user === "student") {
            setActiveTab("student"); // Set Student login as active
        }
    }, [user]);

    return (
        <div className="login-background">
            <div className="login-main-container login-main-container-two">
                <div className="row login-form-part">
                    <div className="card login-form">
                        <nav className="nav-butn">
                            <div
                                style={{ flexWrap: "nowrap", display: "flex" }}
                                className="nav nav-tabs login-nav login-nav-tabs"
                                id="nav-tab"
                                role="tablist"
                            >
                                <button
                                    className={`nav-link login-nav-link ${activeTab === "student" ? "active" : ""}`}
                                    id="nav-home-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#nav-home"
                                    type="button"
                                    role="tab"
                                    aria-controls="nav-home"
                                    aria-selected={activeTab === "student"}
                                    onClick={() => setActiveTab("student")}
                                >
                                    Student Login
                                </button>
                                <button
                                    className={`nav-link login-nav-link ${activeTab === "tutor" ? "active" : ""}`}
                                    id="nav-profile-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#nav-profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="nav-profile"
                                    aria-selected={activeTab === "tutor"}
                                    onClick={() => setActiveTab("tutor")}
                                >
                                    Tutor Login
                                </button>
                            </div>
                        </nav>
                        <div className="tab-content" id="nav-tabContent">
                            <div
                                className={`tab-pane fade ${activeTab === "student" ? "show active" : ""}`}
                                id="nav-home"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab"
                            >
                                <div className="form-body pt-4">
                                    <StudentLogin />
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === "tutor" ? "show active" : ""}`}
                                id="nav-profile"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab"
                            >
                                <div className="form-body pt-4">
                                    <TutorLogin />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
